import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
import { CompareProvider } from '@/context/compare';

// components
import Compare from '@/braun/components/organisms/Compare';

export default () => {
  i18n.loadNamespaces('listing', () => {
    const el = document.getElementById('js-r-compare-entry');
    const CompareApp = () => (
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<div />}>
          <CompareProvider>
            <Compare />
          </CompareProvider>
        </Suspense>
      </I18nextProvider>
    );
    ReactDOM.render(<CompareApp />, el);
  });
};
